import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { settings } from '../environments/environment';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isRelativeApiOrMedia = req.url.startsWith('/api/');

    if (isRelativeApiOrMedia) {
      const apiReq = req.clone({
        withCredentials: true,
        url: `${settings.BASE_URL}${req.url}`
      });
      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
